import { useEffect } from 'react'
import { Outlet, Navigate, useLocation } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { authService } from '@/services/api'
import { useAuthStore } from '@/stores/authStore'

export function ProtectedRoute() {
	const location = useLocation()
	const { isAuthenticated, setAuthenticated, clearAuth } = useAuthStore()

	const { data, isLoading, isError } = useQuery({
		queryKey: ['auth', 'check'],
		queryFn: authService.check,
		retry: false,
		staleTime: 5 * 60 * 1000,
	})

	useEffect(() => {
		if (data?.authenticated && data.email) {
			setAuthenticated(data.email)
		} else if (data && !data.authenticated) {
			clearAuth()
		}
		if (isError) {
			clearAuth()
		}
	}, [data, isError, setAuthenticated, clearAuth])

	if (isLoading) {
		return (
			<div className="flex min-h-screen items-center justify-center">
				<div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-200 border-t-primary-600" />
			</div>
		)
	}

	if (isError || !isAuthenticated && data && !data.authenticated) {
		return <Navigate to="/login" state={{ from: location }} replace />
	}

	return <Outlet />
}
